// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-MultipleChoice-editor-MultipleChoiceEditor-module__container";
var _2 = "webpack-concepts-Extraction-Blocks-MultipleChoice-editor-MultipleChoiceEditor-module__optionItem";
var _3 = "webpack-concepts-Extraction-Blocks-MultipleChoice-editor-MultipleChoiceEditor-module__optionItemDash";
var _4 = "webpack-concepts-Extraction-Blocks-MultipleChoice-editor-MultipleChoiceEditor-module__optionList";
export { _1 as "container", _2 as "optionItem", _3 as "optionItemDash", _4 as "optionList" }
